import { notify } from "@/components/Shares/Notification";
import { sendEnquiry } from "@/service/enquiry";
import { Button, Input, Textarea } from "@nextui-org/react";
import { isEqual } from "lodash";
import { useState } from "react";

const Enquiry = () => {
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [category, setCategory] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSendMessage = async () => {
    if (isEqual(name, "")) {
      notify("Please enter your name", "error");
      return;
    }

    if (isEqual(surname, "")) {
      notify("Please enter your surname", "error");
      return;
    }

    if (isEqual(name, "")) {
      notify("Please enter you phone number", "error");
      return;
    }

    if (isEqual(email, "")) {
      notify("Please enter your email", "error");
      return;
    }

    if (message.trim().split(/\s+/).length < 10) {
      notify("Message must be at least 10 words", "error");
      return;
    }

    const payload = {
      name,
      surname,
      phone,
      email,
      category,
      subject,
      message,
    };
    const res = await sendEnquiry(payload);
    notify("Thank you for contact, we will get back to you soon", "success");
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 py-24 border-t">
      <h2 className="col-span-1 text-2xl font-semibold mb-12">
        Store purchases & general contact inquiries
      </h2>
      <div className="col-span-3">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          <Input
            label="NAME"
            radius="none"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            label="SURNAME"
            radius="none"
            value={surname}
            onChange={(e) => setSurname(e.target.value)}
          />
          <Input
            label="PHONE"
            radius="none"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <Input
            label="EMAIL"
            radius="none"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            label="REQUEST CATEGORY"
            radius="none"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
          <Input
            label="SUBJECT"
            radius="none"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
        <Textarea
          label="MESSAGE"
          radius="none"
          rows={4}
          className="mb-16"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <Button
          className="text-white text-lg bg-icon px-8 py-6 rounded-md shadow-card"
          onClick={() => handleSendMessage()}
        >
          Send Message
        </Button>
      </div>
    </div>
  );
};

export default Enquiry;
